module.exports = __webpack_public_path__ + "static/img/_szafa_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/_szafa_42.svg
// module id = +HSq
// module chunks = 0